import React, { useEffect, useState } from "react";
import { Field, FormikProvider, Form, useFormik } from "formik";
import Menubar from "../Menubar";
import { store } from "../../App";
import { IoIosReturnLeft } from "react-icons/io";
import MasterService from "../../Services/MasterService";
import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai";
import { IoReturnDownForward } from "react-icons/io5";

import {
  Container,
  Row,
  Col,
  Nav,
  Modal,
  Button,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { RiUserFollowLine } from "react-icons/ri";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import { FaRegFile, FaUserCheck, FaRegSave } from "react-icons/fa";
import autoTable from "jspdf-autotable";
import KpiService from "../../Services/KpiService";
import {
  allowNumberswithMaxLengthcatidtypeOnly,
  allowNumberswithMaxLengthtypeOnly,
  currentDate,
  exportToentryExcel,
  formatNumberIndianWithDecimal,
  generateentryPdf,
  convertFormattedToPlainNumber,
  denomallowNumberswithMaxLengthtypeOnly,
  isFY2025OrLater,
} from "../utils/commonFunctions";
import AlertModal from "../Alert/AlertModal";
import useAlert from "../Alert/useAlert";
import { Link } from "@mui/material";

export default function KpiIndicatorEntry() {
  const [showModal, setShowModal] = useState(false);
  const [distEnb, setDistEnb] = useState(false);
  const [mandalenb, setMandalenb] = useState(false);
  const [distlist, setDistlist] = useState();
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const [categorylist, setCategorylist] = useState();
  const [workFlow, setWorkFlow] = useState([]);
  const [currentstatus, setCurrentstatus] = useState("");
  const [mandallist, setMandallist] = useState();
  const [yearlist, setYearlist] = useState();
  const [Id, setId] = useState();
  const [periodicid, setPeriodicid] = useState();
  const [EntryData, setEntrydata] = useState();
  const [entrydataEnb, setEntrydataEnb] = useState(false);
  const [sequenceId, setSequenceId] = useState();
  const [Roleeid, setRoleeid] = useState();
  const [addModal, setAddModal] = useState();
  const [mandalId, setMandalId] = useState();
  const [distId, setDistId] = useState();
  const [searchText, setSearchText] = useState("");
  const [cpoTableenb, setCpoTableenb] = useState(false);
  const [cpodata, setCpodata] = useState([]);
  const [mandalCpo, setMandalCpo] = useState();
  const [Year, setYear] = useState();
  const [HeadId, setHeadId] = useState();
  const [fieldenb, setFieldenb] = useState(false);
  const [statusId, setStatusId] = useState();
  let district = localStorage.getItem("districtid");
  let mandal = localStorage.getItem("mandalid");
  let deptId = localStorage.getItem("deptid");
  let username = localStorage.getItem("username");
  let roleid = localStorage.getItem("role");
  let deptName = localStorage.getItem("deptName");
  let ulbdeptlist = JSON.parse(localStorage.getItem("ulbdeptlist") || "[]");
  let ulbcode = localStorage.getItem("ulbid");
  let ulbname = localStorage.getItem("ulbname");
  const [newincenb, setNewincenb] = useState();
  const [newindbutton, setNewindbutton] = useState();
  const formik = useFormik({
    initialValues: {
      userId: "",
      district_id: "",
      department_id: "",
      mandal_id: "",
      periodic_id: "",
      ind_type: "",
      category: "",
      year: "",
      date: "",
      ind_phase: "",
      Indicators: [
        {
          indicator_id: "",
          entry_value: "",
          numerator: "",
          denominator: "",
          unit_cat_id: "",
          multiplir: "",
          columns: "",
          maxLength: "",
          type: "",
          unit: "",
          iszero: "",
          status_id: "",
          targetenb: false,
          ind_type: "",
          ind_phase: "",
          economicRemarks: "",
        },
      ],
      remarks: "",
    },
  });
  const handleClose = () => {
    setAddModal(false);
  };
  const handleClosepop = () => {
    setShowModal(false);
  };
  React.useEffect(() => {
    if (roleid === "31" || roleid === "3" || roleid === "10") {
      setDistEnb(true);
      setMandalenb(true);
    }
    if (roleid === "60" || roleid === "5") {
      setDistEnb(false);
    }
    if (roleid === "32" || roleid === "2") {
      setMandalenb(false);
      setDistEnb(true);
    }
    formik.setFieldValue("district_id", district !== "0" ? district : "");
    let params = { district_id: district };
    MasterService.getMandals(params).then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.id}>
              {" "}
              {item.value}{" "}
            </option>
          );
        });
        setMandallist(options);
      }
    });
    formik.setFieldValue(
      "mandal_id",
      mandal !== "0" && mandal !== "00" ? mandal : "",
    );
  }, []);
  const Emptyfields = () => {
    formik.setFieldValue("periodic_id", "");
    formik.setFieldValue("year", "");
    formik.setFieldValue("category", "");
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === "Escape") {
      e.preventDefault();
      e.stopPropagation();
    }
  };
  const [deptlist, setDeptlist] = useState([]);
  const [data, setData] = useState(null); const periodicityMap = { monthly: { label: "MONTHLY", value: "6" }, quarterly: { label: "QUARTERLY", value: "7" }, half_yearly: { label: "HALFYEARLY", value: "5" }, annually: { label: "ANNUALLY", value: "3" }, bi_annual: { label: "BIENNIAL", value: "8" }, five_years: { label: "FIVE-YEARS", value: "2" }, };
  const [syn, setSyn] = useState();
  useEffect(() => {
    if (data) {
      const firstKey = Object.entries(periodicityMap).find(
        ([key]) => data?.[key] > 0,
      );
      if (firstKey) {
        const { value } = firstKey[1];
        setActivePeriodicity(value);
        const syntheticEvent = { target: { name: "periodic_id", value } };
        YearData(syntheticEvent);
        setSyn(syntheticEvent);
        formik.handleChange(syntheticEvent);
      }
    }
  }, [data]);

  useEffect(() => {
    store.dispatch({ type: "SHOW_SPINNER" });
    if (roleid !== "8") {
      let paramss = { userId: username, deptId: deptId, mandal: "Yes", district: "No", state: "No", secretariat: "No", };
      KpiService.getperiodicityStatusForAchievementsEntry(paramss).then(
        (res) => {
          if (res.data.SCODE === "01") { setData(res.data.SDESC[0]); setPeriodiclistenb(true); }
          else { showAlertMessage(res.data.SDESC, "warning"); setPeriodiclistenb(false); }
        },
      );
    }
    MasterService.getDistricts().then((res17) => {
      if (res17.data) {
        let options = res17.data.map((item, i) => { return (<option key={i} value={item.id}> {" "} {item.value}{" "} </option>); });
        setDistlist(options);
      }
    });
    if (roleid === "8") {
      let paramss = { userId: username };
      MasterService.getDeptartments(paramss).then((res) => {
        if (res.data) { let options = res.data?.SDESC.map((item, i) => { return (<option key={i} value={item.dept_id}> {" "} {item.dept_name}{" "} </option>); }); setDeptlist(options); }
      });
    } store.dispatch({ type: "HIDE_SPINNER" });
  }, []);
  // useEffect(() => { const handleScroll = () => { ReactTooltip.hide(); }; window.addEventListener("scroll", handleScroll); return () => { window.removeEventListener("scroll", handleScroll); }; }, []);

  useEffect(() => {
    formik.values?.Indicators?.forEach((item, i) => {
      if (item.columns === 3) {
        if (!item.numerator || !item.denominator) {
          formik.setFieldValue(`Indicators.${i}.entry_value`, "");
        } else if (item.denominator !== 0) {
          const multiplier = item.multiplir;
          const devider = item.devider;
          const mainval = multiplier
            ? (
              (parseFloat(item.numerator) / parseFloat(item.denominator)) *
              parseInt(item.multiplir)
            ).toFixed(3)
            : multiplier === "" && devider
              ? (
                parseFloat(item.numerator) /
                parseFloat(item.denominator) /
                parseInt(item.devider)
              ).toFixed(3)
              : (
                parseFloat(item.numerator) / parseFloat(item.denominator)
              ).toFixed(3);
          formik.setFieldValue(
            `Indicators.${i}.entry_value`,
            isFinite(mainval) ? mainval : "0.000",
          );
        }
      }
      if (item.columns === 4) {
        if (!item.numerator || !item.denominator) {
          formik.setFieldValue(`Indicators.${i}.entry_value`, "");
        } else if (item.denominator !== 0) {
          const multiplier = item.multiplir;
          const devider = item.devider;
          const mainval = multiplier
            ? (
              ((parseFloat(item.numerator) - parseFloat(item.denominator)) /
                parseFloat(item.denominator)) *
              parseInt(item.multiplir)
            ).toFixed(3)
            : multiplier === "" && devider
              ? (
                (parseFloat(item.numerator) - parseFloat(item.denominator)) /
                parseFloat(item.denominator) /
                parseInt(item.devider)
              ).toFixed(3)
              : (
                parseFloat(item.numerator) / parseFloat(item.denominator)
              ).toFixed(3);
          formik.setFieldValue(
            `Indicators.${i}.entry_value`,
            isFinite(mainval) ? mainval : "0.000",
          );
        }
      }
    });
  }, [formik.values.Indicators]);

  const MandalDropdown = (e) => {
    if (!e.target.value) {
      return;
    }
    setDistId(e.target.value);
    formik.setFieldValue("year", "");
    formik.setFieldValue("date", "");
    formik.setFieldValue("category", "");
    let params = { district_id: e.target.value };
    MasterService.getMandals(params).then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.id}>
              {" "}
              {item.value}{" "}
            </option>
          );
        });
        setMandallist(options);
      }
    });
    setEntrydataEnb(false);
  };

  const YearData = (e) => {
    formik.setFieldValue("year", "");
    formik.setFieldValue("date", "");
    formik.setFieldValue("category", "");
    setEntrydataEnb(false);
    setCpoTableenb(false);
    if (!e.target.value) {
      return;
    }
    setPeriodicid(e.target.value);
    setId("");
    let params = {
      userId: username,
      periodicityId: e.target.value || activePeriodicity,
    };
    KpiService.KpiperiodicYears(params).then((res20) => {
      let years = res20.data?.SDESC?.yearsList || []; let res = years;
      if (res20.data) { let options = res.map((item, i) => { return (<option key={i} value={item.id}> {" "} {item.value}{" "} </option>); }); setYearlist(options); }
    });
    setYearlist([]);
    setEntrydataEnb(false);
  };
  const Categorydata = (e) => {
    setEntrydataEnb(false); setCategorylist([]); formik.setFieldValue("category", ""); formik.setFieldValue("date", "");
    if (!e.target.value) {
      let missingFields = [];
      if (roleid === "8") { if (!formik.values.district_id) missingFields.push("District"); if (!formik.values.mandal_id) missingFields.push("Mandal"); }
      if (formik.values.periodic_id) missingFields.push("Periodicity");
      if (!e.target.value) missingFields.push("Year");
      const errorMessage = `Please Select Required Field ${missingFields.join(", ")}.`;
      showAlertMessage(errorMessage, "warning"); setEntrydataEnb(false); setCpoTableenb(false);
      return;
    }
    const selectedYear = e.target.value; setId(selectedYear);
    if (["1", "2", "3", "8"].includes(periodicid)) {
      if (!["31", "3", "8"].includes(roleid)) {
        let paramss = { userId: username, districtId: roleid === "60" || roleid === "5" ? distId : district, periodicityId: formik.values.periodic_id || syn?.target?.value, year: e.target.value, deptId: roleid === "8" ? formik.values.department_id : deptId, headId: "0", };
        CountData(paramss);
      } else {
        const params = {
          userId: username,
          districtId:
            roleid === "60" || roleid === "5" || roleid === "8"
              ? distId
              : district,
          mandalId: ulbdeptlist.includes(deptId) ? "0" : mandal,
          ulbId: ulbdeptlist.includes(deptId) ? ulbcode : "0",
          year: e.target.value,
          headId: "0",
          deptId: roleid === "8" ? formik.values.department_id : deptId,
          periodicityId: formik.values.periodic_id || syn?.target?.value,
        };
        fetchEntryData(params, selectedYear);
      }
    } else {
      const params = { userId: username, periodicityId: periodicid, year: e.target.value, };
      KpiService.kpiperiodicityMasterFutureDatesExtension(params).then(
        (res) => {
          const response = res.data.SDESC.headList;
          const options = response.map((item, i) => (
            <option key={i} value={item.id}>
              {" "}
              {item.value}{" "}
            </option>
          ));
          setCategorylist(options);
        },
      );
    }
  };

  const CountData = (params) => {
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.CpoTableData(params)
      .then((res) => {
        if (res.data.SCODE === "02") {
          showAlertMessage(res.data.SDESC, "warning");
        }
        if (res.data.SCODE === "01") {
          setCpodata(res.data.SDESC);
          setCpoTableenb(true);
          setEntrydataEnb(false);
          res.data.SDESC.map((item, i) => {
            if (item.year !== null) {
              setYear(item.year);
            }
            if (item.head_id !== null) {
              setHeadId(item.head_id);
            }
          });
        } else {
          setCpodata([]);
          showAlertMessage(res.data.SDESC, "warning");
        }
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };
  const [buttonenb, setButtonenb] = useState();
  const getEntrydata = (e) => {
    if (!e.target.value) {
      let missingFields = [];
      if (!e.target.value) missingFields.push("Category");
      const errorMessage = `Please Select Required Field ${missingFields.join(", ")}.`;
      showAlertMessage(errorMessage, "warning");
      setCpoTableenb(false);
      setEntrydataEnb(false);
      return;
    }
    if (roleid === "32" || roleid === "2") {
      let paramss = {
        userId: username,
        districtId: roleid === "60" || roleid === "5" ? distId : district,
        periodicityId: formik.values.periodic_id || syn?.target?.value,
        year: formik.values.year,
        headId: e.target.value,
        deptId: roleid === "8" ? formik.values.department_id : deptId,
      };
      CountData(paramss);
    } else {
      const params = {
        userId: username,
        districtId:
          roleid === "60" || roleid === "5" || roleid === "8"
            ? formik.values.district_id
            : district,
        mandalId: ulbdeptlist.includes(deptId) ? "0" : mandal,
        ulbId: ulbdeptlist.includes(deptId) ? ulbcode : "0",
        year: formik.values.year,
        headId: e.target.value,
        deptId: roleid === "8" ? formik.values.department_id : deptId,
        periodicityId: formik.values.periodic_id || syn?.target?.value,
      };
      fetchEntryData(params, formik.values.year);
    }
  };

  const fetchEntryData = (params, selectedYear) => {
    formik.setFieldValue("Indicators", []);
    setSequenceId(null);
    if (roleid === "32" || roleid === "2") {
      setCpoTableenb(true);
      setEntrydataEnb(false);
      setNewincenb(false);
    }
    if (
      roleid === "31" ||
      roleid === "60" ||
      roleid === "3" ||
      roleid === "5" ||
      roleid === "8"
    ) {
      setCurrentstatus("");
      setWorkFlow([]);
      formik.values.Indicators.map((item, index) => {
        formik.setFieldValue(`Indicators[${index}].targetenb`, false);
        formik.setFieldValue(`Indicators[${index}].entry_value`, "");
        formik.setFieldValue(`Indicators[${index}].numerator`, "");
        formik.setFieldValue(`Indicators[${index}].denominator`, "");
      });
      store.dispatch({ type: "SHOW_SPINNER" });
      KpiService.Kpientrydata(params)
        .then((res) => {
          console.log(selectedYear, "sel");
          if (res.data.SCODE === "01") {
            setEntrydataEnb(true);
            setCpoTableenb(false);
            setEntrydata(res.data.SDESC);
            setCurrentstatus(res.data.WorkFlowCurrentStatus[0]?.status || "");
            setWorkFlow(res.data.getWorkFlow || []);
            let enb = true;
            let newenb = false;
            let newindbutton = false;
            res.data.SDESC.forEach((item, i) => {
              formik.setFieldValue(
                `Indicators[${i}].entry_value`,
                item.unit_cat_id === 13
                  ? (() => {
                    const raw = item.indicator_value;
                    if (raw == null || raw === "") return "";
                    if (isNaN(raw)) return raw;
                    const num = +raw;
                    return Number.isInteger(num)
                      ? num
                      : Math.floor(num * 1000) / 1000;
                  })()
                  : item.indicator_value == null
                    ? ""
                    : item.indicator_value,
              );
              formik.setFieldValue(`Indicators[${i}].iszero`, item.iszero);
              formik.setFieldValue(`Indicators[${i}].ind_type`, item.ind_type);
              formik.setFieldValue(
                `Indicators[${i}].ind_phase`,
                item.ind_phase,
              );
              formik.setFieldValue(
                `Indicators[${i}].economicRemarks`,
                item.maker_remarks,
              );

              formik.setFieldValue(
                `Indicators[${i}].status_id`,
                item.status_id,
              );

              formik.setFieldValue(
                `Indicators[${i}].indicator_id`,
                item.indicator_id === null ? "" : item.indicator_id,
              );
              formik.setFieldValue(
                `Indicators[${i}].columns`,
                item.no_of_columns === null ? "" : item.no_of_columns,
              );
              formik.setFieldValue(
                `Indicators[${i}].maxLength`,
                item.max_length === null ? "" : item.max_length,
              );
              formik.setFieldValue(
                `Indicators[${i}].type`,
                item.rec_type === null ? "" : item.rec_type,
              );
              formik.setFieldValue(
                `Indicators[${i}].unit`,
                item.unit === null ? "" : item.unit,
              );
              formik.setFieldValue(
                `Indicators[${i}].numerator`,
                item.numerator === null ? "" : item.numerator,
              );
              formik.setFieldValue(
                `Indicators[${i}].denominator`,
                item.denominator === null ? "" : item.denominator,
              );
              formik.setFieldValue(
                `Indicators[${i}].multiplir`,
                item.multiplir,
              );
              formik.setFieldValue(
                `Indicators[${i}].devider`,
                item.devider === null ? "" : item.devider,
              );
              formik.setFieldValue(
                `Indicators[${i}].targets_2025`,
                item.targets_2025 === null ? "" : item.targets_2025,
              );
              formik.setFieldValue(
                `Indicators[${i}].unit_cat_id`,
                item.unit_cat_id === null ? "" : item.unit_cat_id,
              );
              if (isFY2025OrLater(selectedYear)) {
                console.log(
                  `Indicator ${i + 1} targets_2025:`,
                  item.targets_2025,
                );
                {
                  item.targets_2025 === null
                    ? formik.setFieldValue(`Indicators[${i}].targetenb`, true)
                    : formik.setFieldValue(`Indicators[${i}].targetenb`, false);
                }
              }

              if (item.sequence_id !== null) {
                setSequenceId(item.sequence_id);
              }
              if (item.targets_2025 !== null) {
                enb = false;
              }
              if (item.ind_type === "N") {
                newindbutton = false;
              }
              if (!isFY2025OrLater(selectedYear)) {
                if (item.ind_type === "N" && ![2, 4].includes(item.status_id)) {
                  newenb = true;
                  console.log("tst,", item.status_id);
                }
              }
            });
            if (newenb) {
              console.log(newenb);
              setNewincenb(true);
            }
            if (newindbutton) {
              setNewindbutton(true);
            }

            if (isFY2025OrLater(selectedYear) && enb) {
              showAlertMessage(
                "Entry is not allowed because target values have not yet been entered for all indicators.",
                "warning",
              );
            }
            const allIndicators = res.data.SDESC || [];
            const hasNtype = allIndicators.some(
              (item) => item.ind_type === "N",
            );
            let showButtons = false;
            if (isFY2025OrLater(selectedYear)) {
              // const hasAnyTarget = allIndicators.some(item => item.targets_2025 !== null);
              const hasEditableTarget = allIndicators.some(
                (item) =>
                  item.targets_2025 !== null &&
                  ![2, 4].includes(item.status_id),
              );
              const allNoTargets = allIndicators.every((item) => item.targets_2025 === null,);

              if (allNoTargets) { showButtons = false; }
              else if (hasEditableTarget) { showButtons = true; }
              else { showButtons = false; }
            } else {
              if (hasNtype) {
                // Show buttons if any N type indicator has status_id 0 or 1
                if (
                  allIndicators.some((item) => item.ind_type === "N" && [0, 1].includes(item.status_id),)
                ) {
                  showButtons = true;
                } else {
                  showButtons = false;
                }
              } else {
                if (
                  allIndicators.some((item) => item.ind_type === "O" && [2, 4].includes(item.status_id),)
                ) {
                  showButtons = false;
                } else {
                  showButtons = true;
                }
              }
            }
            setButtonenb(showButtons);
            console.log("Button visibility:", showButtons);
          } else {
            setEntrydata([]);
            setEntrydataEnb(false);
            showAlertMessage(res.data.SDESC, "warning");
          }
          if (res.data.SCODE != "02") {
            if (Array.isArray(res.data.statusCheck) && res.data.statusCheck.length > 0) { setStatusId(res.data.statusCheck[0]?.status_id); setRoleeid(res.data.statusCheck[0]?.role_id); }
            else { setRoleeid(31); setStatusId("0"); }
            setFieldenb(
              (roleid === "31" || roleid === "3") &&
                (res.data.statusCheck[0]?.role_id === 200 ||
                  res.data.statusCheck[0]?.role_id === 32 ||
                  res.data.statusCheck[0]?.role_id === 2 ||
                  res.data.statusCheck[0]?.role_id === 60)
                ? true
                : (roleid === "32" || roleid === "2") &&
                  (res.data.statusCheck[0]?.role_id === 31 || res.data.statusCheck[0]?.role_id === 3 || res.data.statusCheck[0]?.role_id === 200 || res.data.statusCheck[0]?.role_id === 60)
                  ? true
                  : roleid === "8" && res.data.statusCheck[0]?.role_id === 200 ? true : false,
            );
          }
        })
        .finally(() => {
          store.dispatch({ type: "HIDE_SPINNER" });
        });
    }
  };

  let hasOldStatus = false;
  hasOldStatus = formik.values.Indicators.some((ind) =>
    [2, 4].includes(ind.status_id),
  );
  const filteredData =
    searchText.length > 0 && cpodata?.length
      ? cpodata.filter((item) => {
        return (
          item &&
          Object.keys(item).some((key) => {
            const value = item[key];
            return (
              value !== null &&
              value
                .toString()
                .toLowerCase()
                .includes(searchText.toLowerCase())
            );
          })
        );
      })
      : cpodata;
  const validatevalue = () => {
    let val = false;
    formik.values.Indicators.map((item, index) => {
      if (item.entry_value) {
        val = true;
      }
    });
    return val;
  };

  const restrictToPasteEightDotThreeHandler = (
    formik, fieldName, index, isAllowedNegative, unit_cat_id,) => ({
      onPaste: (e) => {
        e.preventDefault();
        const pasted = e.clipboardData.getData("text").trim();

        if (pasted === "-") { showAlertMessage("Please enter a valid number, not just '-'.", "warning",); return; }

        if (unit_cat_id !== 1 && pasted.includes(",")) { showAlertMessage("Commas are not allowed in this field.", "warning"); return; }

        const cleanValue = pasted.replace(/,/g, ""); const numericValue = parseFloat(cleanValue); const isNumeric = !isNaN(numericValue); const baseRegex = /^-?\d{1,8}(\.\d{1,3})?$/;

        if (!baseRegex.test(cleanValue)) {
          showAlertMessage("Only numbers with up to 8 digits before and 3 digits after the decimal point are allowed.", "warning",);
          return;
        }
        if (isNumeric) {
          const rule = `${isAllowedNegative}`.trim();
          if (rule === "null" || rule === "" || rule === "undefined" || isAllowedNegative == null) {
            if (numericValue <= 0) { showAlertMessage("Only positive numbers are allowed.", "warning"); return; }
          } else {
            switch (rule) {
              case "1":
                if (numericValue <= 0) { showAlertMessage("Only positive numbers are allowed.", "warning",); return; }
                break;
              case "0":
                if (numericValue < 0) { showAlertMessage("Negative numbers are not allowed.", "warning",); return; }
                break; case "-1": break; default:
                showAlertMessage("Invalid configuration for number restrictions.", "warning",);
                return;
            }
          }
        }
        formik.setFieldValue(`Indicators[${index}].${fieldName}`, pasted);
      },
    });

  const restrictToPasteOnlyEightDotThreeAllowKeyPress = (
    formik,
    fieldName,
    index,
  ) => ({
    onPaste: (e) => {
      e.preventDefault();
      const pasted = e.clipboardData.getData("text").trim();
      const regex = /^\d{1,8}(\.\d{1,3})?$/;
      if (regex.test(pasted)) {
        formik.setFieldValue(`Indicators[${index}].${fieldName}`, pasted);
      } else {
        showAlertMessage(
          "Only Positive numbers with up to 8 digits before the decimal point and up to 3 digits after the decimal point are allowed. ",
          "warning",
        );
      }
    },
  });

  const SaveEntryData = () => {
    let enable = validatefieldvalues();
    const val = validatevalue();
    if (!val) {
      showAlertMessage("At least one entry value must be provided.", "warning");
      return;
    }
    if (enable) {
      return;
    }
    let stat = 1;
    formik.values.Indicators.map((item, index) => {
      if (item.status_id === 2) {
        stat = 2;
      }
      if (item.status_id === 4) {
        stat = 4;
      }
    });
    let params = {
      type: "save",
      userId: username,
      dept_id: roleid === "8" ? formik.values.department_id : deptId,
      district_id: roleid === "8" ? formik.values.district_id : district,

      mandal_id: ulbdeptlist.includes(deptId) ? "0" : mandal,
      ulbId: ulbdeptlist.includes(deptId) ? ulbcode : "0",
      sequence_id: sequenceId,
      periodicity_id: periodicid,
      remarks: formik.values.remarks,
      year: formik.values.year || 0,
      head_id: formik.values.category || 0,
      indicaterEntryDto: [],
    };
    params.indicaterEntryDto = formik.values.Indicators.map((item, index) =>
      item.entry_value
        ? {
          indicator_id: item.indicator_id,
          unit: item.unit,
          indicator_value:
            item.unit_cat_id === 13
              ? item.entry_value
              : convertFormattedToPlainNumber(item.entry_value),
          numerator: convertFormattedToPlainNumber(item.numerator) || 0,
          denominator: convertFormattedToPlainNumber(item.denominator) || 0,
          indicatorType: item.ind_type,
          makerRemarks: item.economicRemarks,
          status_id: item.status_id,
        }
        : null,
    ).filter(Boolean);

    store.dispatch({ type: "SHOW_SPINNER" });

    KpiService.SaveKpiMandalentry(params)
      .then((res) => {
        if (res.data.SCODE === "01") {
          showAlertMessage(res.data.SDESC, "success", () => {
            const fetchParams = {
              userId: username,
              districtId: formik.values.district_id,
              mandalId: ulbdeptlist.includes(deptId) ? "0" : mandal,
              ulbId: ulbdeptlist.includes(deptId) ? ulbcode : "0",
              year: formik.values.year,
              headId: formik.values.category || 0,
              deptId: roleid === "8" ? formik.values.department_id : deptId,
              periodicityId: formik.values.periodic_id || syn?.target?.value,
            };
            formik.values.Indicators.map((item, index) => {
              formik.setFieldValue(`Indicators[${index}].targetenb`, false);
            });
            fetchEntryData(fetchParams, formik.values.year);
          });
        } else {
          showAlertMessage(res.data.SDESC, "warning");
        }
      })
      .catch((err) => {
        showAlertMessage("Failed to save data. Please try again.", "warning");
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };

  const handleInputChange = (e, index, field, isZero) => {
    const rawValue = e.target.value.trim();

    if (rawValue === "-") {
      showAlertMessage(
        "Please enter a valid number, not just '-'.",
        "warning",
        () => {
          formik.setFieldValue(`Indicators[${index}].${field}`, "");
        },
      );
      return;
    }

    const sanitizedValue = rawValue.replace(/,/g, "");
    const numericValue = parseFloat(sanitizedValue);

    const isZeroRule = parseInt(isZero);
    const isDenominator = field === "denominator";

    if (!isNaN(numericValue)) {
      if (isDenominator) {
        if (numericValue <= 0 && ![0, -1].includes(isZeroRule)) {
          showAlertMessage(
            "Denominator must be a positive number",
            "warning",
            () => {
              formik.setFieldValue(`Indicators[${index}].${field}`, "");
            },
          );
          return;
        }
      } else {
        if (numericValue === 0 && isZeroRule === 1) {
          showAlertMessage(
            "Only positive numbers are allowed for this indicator",
            "warning",
            () => {
              formik.setFieldValue(`Indicators[${index}].${field}`, "");
            },
          );
          return;
        }

        if (numericValue === 0 && ![0, -1].includes(isZeroRule)) {
          showAlertMessage(
            "Zero is not allowed for this indicator",
            "warning",
            () => {
              formik.setFieldValue(`Indicators[${index}].${field}`, "");
            },
          );
          return;
        }

        if (numericValue < 0 && isZeroRule !== -1) {
          showAlertMessage(
            "Negative values are not allowed for this indicator",
            "warning",
            () => {
              formik.setFieldValue(`Indicators[${index}].${field}`, "");
            },
          );
          return;
        }
      }
    }

    // All validations passed
    formik.setFieldValue(`Indicators[${index}].${field}`, rawValue);
  };

  const denominatorchange = (index, unit_cat_id) => {
    console.log("formik.values.Indicators[i]?.entry_value", formik.values.Indicators[index]?.entry_value,);
    if (formik.values.Indicators[index]?.entry_value > parseFloat(100) && [2, 9, 11].includes(unit_cat_id)) { showAlertMessage("Achieved Value Exceeded 100%. Kindly check it.", "warning",); }
  };

  const validatefieldvalues = () => {
    let enb = false;
    {
      formik.values?.Indicators?.forEach((item, i) => {
        if (item.columns === 3 || item.columns === 4) {
          if (!item.numerator && item.denominator) {
            showAlertMessage(`Please Enter Numerator!`, "warning");
            enb = true;
          }
          if (item.numerator && !item.denominator) {
            showAlertMessage(`Please Enter Denominator!`, "warning");
            enb = true;
          }
        }
      });
    }
    return enb;
  };

  const validateConsolidatedRemarks = () => {
    const missing = [];

    formik.values.Indicators.forEach((item, index) => {
      const hasTarget =
        item.targets_2025 !== null &&
        item.targets_2025 !== undefined &&
        item.targets_2025 !== "";
      const noRemark = !(item.economicRemarks ?? "").toString().trim();

      if (Number(item.ind_phase) === 4 && hasTarget && noRemark) {
        missing.push(index + 1); // matches the Sl.No. column
      }
    });

    if (missing.length > 0) {
      showAlertMessage(
        `Please enter Maker Remarks for the indicator(s) at Sl.No. ${missing.join(", ")}.`,
        "warning",
      );
      return true;
    }
    return false;
  };

  const submitData = () => {
    const val = validatevalue();
    if (!val) {
      showAlertMessage("At least one entry value must be provided.", "warning");
      return;
    }
    let enable = validatefieldvalues();
    if (enable) {
      return;
    }
    let missingEntries = [];
    formik.values.Indicators.forEach((item, index) => {
      if (
        item.targets_2025 !== null &&
        item.targets_2025 !== "" &&
        (item.entry_value === null || item.entry_value === "")
      ) {
        missingEntries.push(`Indicator ${index + 1}`);
        console.log(`Indicator ${index + 1}`, item.targets_2025);
      }
    });
    console.log("formik.values.Indicators", formik.values.Indicators);
    if (missingEntries.length > 0) {
      showAlertMessage(
        `Please enter values for all indicators which have targets assigned.`,
        "warning",
      );
      return;
    }
    if (validateConsolidatedRemarks()) {
      return;
    }
    setAddModal(true);
    formik.setFieldValue("remarks", "");
  };

  const ForwardDataCpo = () => {
    if (!formik.values.remarks) {
      const errorMessage = "Please Enter Required Field: Remarks.";
      showAlertMessage(errorMessage, "warning");
      return;
    }
    // === Validation: ensure all indicators with targets have entries ===

    let stat = 2;
    formik.values.Indicators.map((item, index) => {
      if (item.status_id === 4) {
        stat = 4;
      }
    });
    const isULB = ulbdeptlist.includes(deptId);
    const params = {
      type: "forward",
      userId: username,
      dept_id: deptId,
      district_id: district,
      newIndicatorsStatus: "2",
      mandal_id: isULB ? "0" : mandal,
      ulbId: isULB ? ulbcode : "0",
      sequence_id: sequenceId,
      status_id: stat,
      role_id: 32,
      periodicity_id: periodicid,
      remarks: formik.values.remarks,
      year: formik.values.year || 0,
      head_id: formik.values.category || 0,
      indicaterEntryDto: [],
    };

    params.indicaterEntryDto = formik.values.Indicators.map((item) => {
      if (!item.entry_value) return null;

      return {
        indicator_id: item.indicator_id,
        indicatorType: item.ind_type,
        unit: item.unit,
        indicator_value:
          item.unit_cat_id === 13
            ? item.entry_value
            : convertFormattedToPlainNumber(item.entry_value),
        numerator: convertFormattedToPlainNumber(item.numerator) || 0,
        denominator: convertFormattedToPlainNumber(item.denominator) || 0,
        status_id: item.status_id,
        makerRemarks: item.economicRemarks,
      };
    }).filter(Boolean);

    formik.values.Indicators.forEach((_, index) => {
      formik.setFieldValue(`Indicators[${index}].targetenb`, false);
    });
    store.dispatch({ type: "SHOW_SPINNER" });

    KpiService.SaveKpiMandalentry(params)
      .then((res) => {
        setShowModal(false);
        showAlertMessage(
          res.data.SDESC,
          res.data.SCODE === "01" ? "success" : "warning",
          () => {
            formik.setFieldValue("remarks", "");
            const fetchParams = {
              userId: username,
              districtId: roleid === "60" || roleid === "5" ? distId : district,
              mandalId: isULB ? "0" : mandal,
              ulbId: isULB ? ulbcode : "0",
              year: Id,
              headId: formik.values.category || 0,
              deptId: deptId,
              periodicityId: periodicid,
            };
            fetchEntryData(fetchParams, formik.values.year);
          },
        );
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };

  const checkVal = () => {
    if (!formik.values.remarks) {
      let missingFields = [];
      if (!formik.values.remarks) missingFields.push("Remarks");
      const errorMessage = "Please Enter Remarks";
      showAlertMessage(errorMessage, "warning");
      return;
    }
    setAddModal(false);
    setShowModal(true);
  };
  const ApproveData = () => {
    let params = {
      type: "approve",
      userId: username,
      dept_id: deptId,
      district_id: formik.values.district_id,
      newIndicatorsStatus: "4",

      mandalId: ulbdeptlist.includes(deptId) ? "0" : mandal,
      ulbId: ulbdeptlist.includes(deptId) ? ulbcode : "0",
      sequence_id: sequenceId,
      status_id: 4,
      role_id: 200,
      periodicity_id: periodicid,
      remarks: formik.values.remarks,
      year: formik.values.year,
      head_id: formik.values.category || 0,
      indicaterEntryDto: [],
    };
    params.indicaterEntryDto = formik.values.Indicators.map((item, index) =>
      item.entry_value
        ? {
          indicator_id: item.indicator_id,
          unit: item.unit,
          indicator_value: item.entry_value,
          indicatorType: item.ind_type,
          numerator: item.numerator || 0,
          denominator: item.denominator || 0,
        }
        : null,
    ).filter(Boolean);
    setShowModal(false);
    setAddModal(false);
    KpiService.SaveKpiMandalentry(params).then((res) => {
      showAlertMessage(
        res.data.SDESC,
        res.data.SCODE === "01" ? "success" : "warning",
        () => {
          formik.setFieldValue("remarks", "");
          const fetchParams = {
            userId: username,
            districtId: formik.values.district_id,
            mandalId: ulbdeptlist.includes(deptId) ? "0" : mandal,
            ulbId: ulbdeptlist.includes(deptId) ? ulbcode : "0",
            year: Id,
            headId: formik.values.category || 0,
            deptId: deptId,
            periodicityId: periodicid,
          };

          KpiService.Kpientrydata(fetchParams)
            .then((res) => {
              if (res.data.statusCheck.length > 0) { setStatusId(res.data.statusCheck[0]?.status_id); setRoleeid(res.data.statusCheck[0]?.role_id); }
              setFieldenb(
                (roleid === "31" || roleid === "3") &&
                  (res.data.statusCheck[0]?.role_id === 200 || res.data.statusCheck[0]?.role_id === 32 || res.data.statusCheck[0]?.role_id === 2 || res.data.statusCheck[0]?.role_id === 60)
                  ? true
                  : (roleid === "32" || roleid === "2") &&
                    (res.data.statusCheck[0]?.role_id === 31 || res.data.statusCheck[0]?.role_id === 3 || res.data.statusCheck[0]?.role_id === 200 || res.data.statusCheck[0]?.role_id === 60)
                    ? true
                    : roleid === "8" && res.data.statusCheck[0]?.role_id === 200
                      ? true : false,
              );
              store.dispatch({ type: "HIDE_SPINNER" });
              if (res.data.WorkFlowCurrentStatus.length > 0) {
                setCurrentstatus(res.data.WorkFlowCurrentStatus[0].status);
                setWorkFlow(res.data.getWorkFlow);
              }
              if (res.data.SCODE === "01") {
                setEntrydata(res.data.SDESC);
                res.data.SDESC.forEach((item, i) => {
                  formik.setFieldValue(
                    `Indicators[${i}].entry_value`,
                    (() => {
                      const raw = item.indicator_value;
                      if (raw == null || raw === "") return "";
                      if (isNaN(raw)) return raw;
                      const num = +raw;
                      return Number.isInteger(num)
                        ? num
                        : Math.floor(num * 1000) / 1000;
                    })(),
                  );
                  formik.setFieldValue(`Indicators[${i}].status_id`, item.status_id,);
                  formik.setFieldValue(`Indicators[${i}].iszero`, item.iszero);
                  formik.setFieldValue(`Indicators[${i}].targets_2025`, item.targets_2025 === null ? "" : item.targets_2025,); formik.setFieldValue(`Indicators[${i}].targets_2025`, item.targets_2025 === null ? "" : item.targets_2025,);
                  formik.setFieldValue(`Indicators[${i}].unit_cat_id`, item.unit_cat_id === null ? "" : item.unit_cat_id,);
                  if (isFY2025OrLater(formik.values.year)) {
                    {
                      item.targets_2025 === null
                        ? formik.setFieldValue(
                          `Indicators[${i}].targetenb`,
                          true,
                        )
                        : formik.setFieldValue(
                          `Indicators[${i}].targetenb`,
                          false,
                        );
                    }
                  }
                  if (item.sequence_id !== null) {
                    setSequenceId(item.sequence_id);
                  }
                });
              }
            })
            .finally(() => {
              store.dispatch({ type: "HIDE_SPINNER" });
            });
        },
      );
    });
  };

  const UpdateCpo = () => {
    const val = validatevalue();
    if (!val) {
      showAlertMessage("At least one entry value must be provided.", "warning");
      return;
    }
    let enable = validatefieldvalues();
    if (enable) {
      return;
    }
    const indicatorEntryValues = formik.values.Indicators.reduce(
      (acc, indicator) => {
        if (indicator.entry_value && indicator.entry_value.trim() !== "") {
          acc[indicator.indicator_id] = indicator.entry_value;
        }
        return acc;
      },
      {},
    );
    const filteredData = EntryData.filter((entry) => {
      const entryValue = indicatorEntryValues[entry.indicator_id];
      return (
        entryValue !== undefined &&
        entryValue !== null &&
        entryValue.trim() !== ""
      );
    });
    let params = {
      type: "save",
      userId: username,
      newIndicatorsStatus: "2",
      dept_id: roleid === "8" ? formik.values.department_id : deptId,
      district_id: roleid === "8" ? formik.values.district_id : district,
      mandalId: ulbdeptlist.includes(deptId) ? "0" : mandal,
      ulbId: ulbdeptlist.includes(deptId) ? ulbcode : "0",
      sequence_id: sequenceId,
      status_id: 2,
      role_id: 32,
      periodicity_id: periodicid,
      remarks: formik.values.remarks,
      year: roleid === "8" ? formik.values.year : Year,
      head_id: HeadId || 0,
      indicaterEntryDto: filteredData.map((entry) => {
        const relatedIndicator =
          formik.values.Indicators.find(
            (ind) => ind.indicator_id === entry.indicator_id,
          ) || {};
        return {
          indicator_id: entry.indicator_id,
          unit: entry.unit,
          indicatorType: entry.ind_type,
          indicator_value: indicatorEntryValues[entry.indicator_id] || "",
          numerator:
            relatedIndicator.numerator === undefined ||
              relatedIndicator.numerator === null
              ? "0"
              : relatedIndicator.numerator,
          denominator:
            relatedIndicator.denominator === undefined ||
              relatedIndicator.numerator === null
              ? "0"
              : relatedIndicator.denominator,
        };
      }),
    };
    formik.values.Indicators.map((item, index) => {
      formik.setFieldValue(`Indicators[${index}].targetenb`, false);
    });
    KpiService.SaveKpiMandalentry(params)
      .then((res) => {
        if (res.data.SCODE === "01") {
          showAlertMessage(res.data.SDESC, "success", () => {
            const fetchParams = {
              userId: username,
              districtId: roleid === "8" ? formik.values.district_id : district,
              mandalId: ulbdeptlist.includes(deptId) ? "0" : mandal,
              ulbId: ulbdeptlist.includes(deptId) ? ulbcode : "0",
              year: roleid === "8" ? formik.values.year : Year,
              headId: HeadId || 0,
              deptId: roleid === "8" ? formik.values.department_id : deptId,
              periodicityId: periodicid,
            };
            KpiService.Kpientrydata(fetchParams).then((res) => {
              store.dispatch({ type: "HIDE_SPINNER" });
              if (res.data.WorkFlowCurrentStatus.length > 0) { setCurrentstatus(res.data.WorkFlowCurrentStatus[0].status); setWorkFlow(res.data.getWorkFlow); }
              if (res.data.SCODE === "01") {
                setEntrydata(res.data.SDESC);
                res.data.SDESC.forEach((item, i) => {
                  formik.setFieldValue(
                    `Indicators[${i}].entry_value`,
                    (() => {
                      const raw = item.indicator_value; if (raw == null || raw === "") return "";
                      if (isNaN(raw)) return raw;
                      const num = +raw;
                      return Number.isInteger(num)
                        ? num
                        : Math.floor(num * 1000) / 1000;
                    })(),
                  );
                  formik.setFieldValue(`Indicators[${i}].targets_2025`, item.targets_2025 === null ? "" : item.targets_2025,); formik.setFieldValue(`Indicators[${i}].targets_2025`, item.targets_2025 === null ? "" : item.targets_2025,);
                  formik.setFieldValue(`Indicators[${i}].unit_cat_id`, item.unit_cat_id === null ? "" : item.unit_cat_id,);
                  formik.setFieldValue(`Indicators[${i}].iszero`, item.iszero);
                  formik.setFieldValue(`Indicators[${i}].status_id`, item.status_id,);
                  if (isFY2025OrLater(formik.values.year)) {
                    {
                      item.targets_2025 === null
                        ? formik.setFieldValue(
                          `Indicators[${i}].targetenb`,
                          true,
                        )
                        : formik.setFieldValue(
                          `Indicators[${i}].targetenb`,
                          false,
                        );
                    }
                  }
                  if (item.sequence_id !== null) {
                    setSequenceId(item.sequence_id);
                  }
                });
              }
            });
          });
        } else {
          showAlertMessage(res.data.SDESC, "warning");
        }
      })
      .catch((err) => {
        showAlertMessage("Failed to save data. Please try again.", "warning");
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };

  const ForwardHodpop = () => {
    const val = validatevalue();
    if (!val) {
      showAlertMessage("At least one entry value must be provided.", "warning");
      return;
    }
    let enable = validatefieldvalues();
    if (enable) {
      return;
    }
    if (isFY2025OrLater(formik.values.year)) {
    }
    setAddModal(true);
  };

  const Subdata = (detail) => {
    formik.setFieldValue("Indicators", [
      {
        indicator_id: "",
        entry_value: "",
        numerator: "",
        denominator: "",
        multiplir: "",
        columns: "",
        maxLength: "",
        type: "",
        unit: "",
      },
    ]);
    setMandalCpo(detail.mandal_code);
    const params = {
      userId: username,
      districtId: detail.district_id,
      mandalId: detail.mandal_code,
      year: Year || 0,
      headId: detail.head_id || 0,
      deptId: detail.dept_id,
      periodicityId: periodicid,
    };
    store.dispatch({ type: "SHOW_SPINNER" });
    setCurrentstatus("");
    setWorkFlow([]);
    formik.values.Indicators.map((item, index) => {
      formik.setFieldValue(`Indicators[${index}].targetenb`, false);
    });
    KpiService.Kpientrydata(params)
      .then((res) => {
        if (
          Array.isArray(res.data.statusCheck) &&
          res.data.statusCheck.length > 0
        ) {
          setStatusId(res.data.statusCheck[0]?.status_id);
          setRoleeid(res.data.statusCheck[0]?.role_id);
        }
        setFieldenb(
          (roleid === "31" || roleid === "3") &&
            (res.data.statusCheck[0]?.role_id === 200 ||
              res.data.statusCheck[0]?.role_id === 32 ||
              res.data.statusCheck[0]?.role_id === 2 ||
              res.data.statusCheck[0]?.role_id === 60)
            ? true
            : (roleid === "32" || roleid === "2") &&
              (res.data.statusCheck[0]?.role_id === 31 ||
                res.data.statusCheck[0]?.role_id === 3 ||
                res.data.statusCheck[0]?.role_id === 200 ||
                res.data.statusCheck[0]?.role_id === 60)
              ? true
              : roleid === "8" && res.data.statusCheck[0]?.role_id === 200
                ? true
                : false,
        );
        if (res.data.SCODE === "01") {
          setEntrydata(res.data.SDESC);
          setCurrentstatus(res.data.WorkFlowCurrentStatus[0]?.status || "");
          setWorkFlow(res.data.getWorkFlow || []);
          res.data.SDESC.forEach((item, i) => {
            formik.setFieldValue(
              `Indicators[${i}].entry_value`,
              (() => {
                const raw = item.indicator_value;
                if (raw == null || raw === "") return "";
                if (isNaN(raw)) return raw;
                const num = +raw;
                return Number.isInteger(num)
                  ? num
                  : Math.floor(num * 1000) / 1000;
              })(),
            );
            formik.setFieldValue(`Indicators[${i}].iszero`, item.iszero);
            formik.setFieldValue(`Indicators[${i}].status_id`, item.status_id);

            formik.setFieldValue(
              `Indicators[${i}].indicator_id`,
              item.indicator_id,
            );
            formik.setFieldValue(
              `Indicators[${i}].columns`,
              item.no_of_columns,
            );
            formik.setFieldValue(`Indicators[${i}].maxLength`, item.max_length);
            formik.setFieldValue(`Indicators[${i}].type`, item.rec_type);
            formik.setFieldValue(`Indicators[${i}].unit`, item.unit);
            formik.setFieldValue(`Indicators[${i}].numerator`, item.numerator);
            formik.setFieldValue(
              `Indicators[${i}].denominator`,
              item.denominator,
            );
            formik.setFieldValue(
              `Indicators[${i}].targets_2025`,
              item.targets_2025 === null ? "" : item.targets_2025,
            );
            formik.setFieldValue(
              `Indicators[${i}].targets_2025`,
              item.targets_2025 === null ? "" : item.targets_2025,
            );
            formik.setFieldValue(
              `Indicators[${i}].unit_cat_id`,
              item.unit_cat_id === null ? "" : item.unit_cat_id,
            );
            if (isFY2025OrLater(formik.values.year)) {
              {
                item.targets_2025 === null
                  ? formik.setFieldValue(`Indicators[${i}].targetenb`, true)
                  : formik.setFieldValue(`Indicators[${i}].targetenb`, false);
              }
            }
            if (item.sequence_id !== null) {
              setSequenceId(item.sequence_id);
            }
          });
        } else {
          setEntrydata([]);
          setEntrydataEnb(false);
          showAlert(res.data.SDESC, "warning");
        }
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
    setCpoTableenb(false);
    setEntrydataEnb(true);
  };
  const [activePeriodicity, setActivePeriodicity] = useState("");
  const [periodiclistenb, setPeriodiclistenb] = useState(false);
  const BackFunct = () => {
    setSearchText("");
    let paramss = {
      userId: username,
      districtId: roleid === "60" || roleid === "5" ? distId : district,
      periodicityId: formik.values.periodic_id || syn?.target?.value,
      year: formik.values.year,
      deptId: roleid === "8" ? formik.values.department_id : deptId,
      headId: formik.values.category ? formik.values.category : "0",
    };
    CountData(paramss);
    setCpoTableenb(true);
    setEntrydataEnb(false);
  };

  const perioicitylist = (e) => {
    formik.setFieldValue("mandal_id", "");
    formik.setFieldValue("district_id", "");
    setPeriodiclistenb(false);
    let paramss = {
      userId: username,
      deptId: e.target.value,
      mandal: "Yes",
      district: "No",
      state: "No",
      secretariat: "No",
    };
    KpiService.getperiodicityStatusForAchievementsEntry(paramss).then((res) => {
      if (res.data) {
        if (res.data.SCODE === "01") {
          setData(res.data.SDESC[0]);
        } else {
          showAlertMessage(res.data.SDESC, "warning");
          setPeriodiclistenb(false);
          setEntrydataEnb(false);
        }
      }
    });
  };

  return (
    <>
      {" "}
      <Menubar />
      <Container fluid style={{ width: "95%" }} className="map-header ">
        {" "}
        <div className="sa-title">
          {" "}
          <h2>
            {" "}
            Indicator{" "}
            <span>
              {" "}
              Entry - {ulbdeptlist.includes(deptId) ? "ULB" : "Mandal"}{" "}
              Level{" "}
            </span>{" "}
          </h2>{" "}
        </div>{" "}
      </Container>
      <Container
        fluid
        style={{ width: "95%" }}
        className="mt-3 outer-page-content-container"
      >
        <FormikProvider value={formik}>
          {" "}
          <Form onSubmit={formik.handleSubmit}>
            <div className="mandal-container p-4">
              <Row>
                {roleid !== "8" && (
                  <Col
                    xs={12}
                    sm={12}
                    lg={3}
                    md={3}
                    xl={3}
                    xxl={3}
                    className="district-select"
                  >
                    {" "}
                    <label className="mb-1 fw-bold">
                      Secretariat Name
                    </label>{" "}
                    <Field
                      className="mb-3 form-control"
                      type="text"
                      name="dept_name"
                      value={localStorage.getItem("SectariatcodeName")}
                      controlId="formBasicEmail"
                      disabled={true}
                      style={{ fontWeight: "bold" }}
                    />{" "}
                  </Col>
                )}
                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
                  {" "}
                  <label className="mb-1 fw-bold"> HOD Name</label>
                  {roleid === "8" ? (
                    <Field
                      component="select"
                      name="department_id"
                      className="mb-3 form-control"
                      onChange={(e) => {
                        Emptyfields();
                        formik.handleChange(e);
                        perioicitylist(e);
                      }}
                      style={{ fontWeight: "bold" }}
                      disabled={
                        deptId === "179" || roleid === "8" ? false : true
                      }
                    >
                      {" "}
                      <option value="">--Select--</option> {deptlist}{" "}
                    </Field>
                  ) : (
                    <Field
                      className="mb-3 form-control"
                      type="text"
                      name="dept_name"
                      value={localStorage.getItem("deptcodeName")}
                      controlId="formBasicEmail"
                      disabled={true}
                      style={{ fontWeight: "bold" }}
                    />
                  )}{" "}
                </Col>
                <Col
                  xs={12}
                  sm={12}
                  lg={3}
                  md={3}
                  xl={3}
                  xxl={3}
                  className="district-select"
                >
                  {" "}
                  <label className="mb-1 fw-bold">District</label>{" "}
                  <Field
                    className="mb-3 form-control"
                    component="select"
                    name="district_id"
                    onChange={(e) => {
                      MandalDropdown(e);
                      Emptyfields();
                      formik.handleChange(e);
                    }}
                    controlId="formBasicEmail"
                    disabled={distEnb}
                    style={{ fontWeight: "bold" }}
                  >
                    {" "}
                    <option value="">--Select--</option> {distlist}{" "}
                  </Field>{" "}
                </Col>
                {roleid !== "32" && roleid !== "2" && (
                  <Col
                    xs={12}
                    sm={12}
                    lg={3}
                    md={3}
                    xl={3}
                    xxl={3}
                    className="mandal-select"
                  >
                    {ulbdeptlist.includes(deptId) ? (
                      <>
                        <label className="mb-1 fw-bold">ULB</label>{" "}
                        <Field
                          className="mb-3 form-control"
                          type="text"
                          name="ulb_id"
                          value={ulbname}
                          disabled={mandalenb}
                          controlId="formBasicEmail"
                          style={{ fontWeight: "bold" }}
                        />{" "}
                      </>
                    ) : (
                      <>
                        <label className="mb-1 fw-bold">Mandal</label>{" "}
                        <Field
                          className="mb-3 form-control"
                          component="select"
                          onChange={(e) => {
                            setMandalId(e.target.value);
                            Emptyfields();
                            formik.handleChange(e);
                            setPeriodiclistenb(true);
                          }}
                          name="mandal_id"
                          disabled={mandalenb}
                          controlId="formBasicEmail"
                          style={{ fontWeight: "bold" }}
                        >
                          {" "}
                          <option value="">--Select--</option> {mandallist}{" "}
                        </Field>{" "}
                      </>
                    )}
                  </Col>
                )}
              </Row>{" "}
            </div>
            {periodiclistenb && (
              <>
                <div className="tabs-top">
                  <Nav
                    variant="pills"
                    className="tabs-row d-flex flex-wrap justify-content-start gap-1 mb-2 mt-4"
                  >
                    {Object.entries(periodicityMap)
                      .filter(([key]) => data?.[key] > 0)
                      .map(([key, { label, value }]) => (
                        <div
                          key={key}
                          className="flex-grow-1 flex-shrink-0"
                          style={{ maxWidth: "120px" }}
                        >
                          <Nav.Item className="tab-boxes-small">
                            {" "}
                            <Nav.Link
                              eventKey={value}
                              onClick={() => {
                                const syntheticEvent = {
                                  target: { name: "periodic_id", value },
                                };
                                setActivePeriodicity(value);
                                YearData(syntheticEvent);
                                formik.handleChange(syntheticEvent);
                                formik.setFieldValue("Indicators", []);
                              }}
                              active={activePeriodicity === value}
                              className="text-center"
                            >
                              {" "}
                              <p className="text-truncate text-center m-0">
                                {label}
                              </p>{" "}
                            </Nav.Link>{" "}
                          </Nav.Item>
                        </div>
                      ))}{" "}
                  </Nav>{" "}
                </div>
                <Row>
                  <Col
                    xs={12}
                    sm={12}
                    lg={3}
                    md={3}
                    xl={3}
                    xxl={3}
                    className="mandal-select "
                    style={{ marginLeft: "15px" }}
                  >
                    {" "}
                    <label className="mb-1 fw-bold">Year</label>{" "}
                    <Field
                      className="form-control"
                      component="select"
                      name="year"
                      controlId="formBasicEmail"
                      onChange={(e) => {
                        Categorydata(e);
                        formik.handleChange(e);
                      }}
                      style={{ fontWeight: "bold" }}
                    >
                      {" "}
                      <option value="">--Select--</option> {yearlist}{" "}
                    </Field>{" "}
                  </Col>
                  {(periodicid === "5" ||
                    periodicid === "6" ||
                    periodicid === "7") && (
                      <Col
                        xs={12}
                        sm={12}
                        lg={3}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mandal-select"
                      >
                        {" "}
                        <label className="mb-1 fw-bold">Category</label>{" "}
                        <Field
                          className="form-control"
                          component="select"
                          name="category"
                          controlId="formBasicEmail"
                          style={{ fontWeight: "bold" }}
                          onChange={(e) => {
                            getEntrydata(e);
                            formik.handleChange(e);
                          }}
                        >
                          {" "}
                          <option value="">--Select--</option> {categorylist}{" "}
                        </Field>{" "}
                      </Col>
                    )}

                  {periodicid === "4" &&
                    (Id === "2025" || Id === "2024" || Id === "2023") && (
                      <Col
                        xs={12}
                        sm={12}
                        lg={3}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mandal-select"
                      >
                        {" "}
                        <label className="mb-1 fw-bold">Date</label>{" "}
                        <Field
                          className="form-control"
                          type="date"
                          name="date"
                          onChange={(e) => {
                            getEntrydata(e);
                            formik.handleChange(e);
                          }}
                          max={currentDate}
                          controlId="formBasicEmail"
                          style={{ fontWeight: "bold" }}
                        />{" "}
                      </Col>
                    )}
                </Row>{" "}
              </>
            )}

            <Nav variant="pills" className="flex-column">
              <Row className="tabs-row">
                {" "}
                <Col
                  xxl={2}
                  xl={2}
                  lg={3}
                  md={3}
                  sm={12}
                  xs={6}
                  className="px-0"
                >
                  {" "}
                </Col>{" "}
                <Col
                  xxl={2}
                  xl={2}
                  lg={3}
                  md={3}
                  sm={12}
                  xs={6}
                  className="px-0"
                >
                  {" "}
                </Col>{" "}
                <Col
                  xxl={2}
                  xl={2}
                  lg={2}
                  md={2}
                  sm={12}
                  xs={12}
                  className="mx-4 px-4"
                >
                  {" "}
                </Col>{" "}
                <Col
                  xxl={2}
                  xl={2}
                  lg={2}
                  md={2}
                  sm={12}
                  xs={12}
                  className="mx-4 px-4"
                >
                  {" "}
                </Col>
                {(roleid === "32" || roleid === "2") && entrydataEnb && (
                  <Col
                    xxl={2}
                    xl={2}
                    lg={2}
                    md={2}
                    sm={12}
                    xs={12}
                    className="mx-4 px-4"
                  >
                    {" "}
                    <Button
                      variant="warning"
                      size="sm"
                      className="btn mx-2 mt-1 warn-btn"
                      onClick={() => {
                        BackFunct();
                      }}
                    >
                      {" "}
                      <IoIosReturnLeft
                        style={{ fontSize: "18px", marginLeft: "5px" }}
                      />{" "}
                      Back{" "}
                    </Button>{" "}
                  </Col>
                )}{" "}
              </Row>
            </Nav>

            {entrydataEnb && (
              <Row className="mt-2">
                <Col xxl={9} xl={9} lg={9} md={12} sm={12} xs={12} className="">
                  <Button
                    variant="danger"
                    size="sm"
                    className="btn mx-2 mt-2 mb-1 pdf-btn"
                    style={{ float: "right", marginLeft: "3px" }}
                    onClick={() =>
                      generateentryPdf(
                        "my-table",
                        formik.values,
                        "KpiIndicatorMandalEntry",
                      )
                    }
                  >
                    PDF
                    <MdOutlinePictureAsPdf />
                  </Button>{" "}
                  <Button
                    variant="success"
                    size="sm"
                    className="btn mx-2 mt-2 mb-1 excel-btn"
                    style={{
                      float: "right",
                      color: "#ffffff",
                      marginLeft: "3px",
                    }}
                    onClick={() =>
                      exportToentryExcel(
                        "my-table",
                        formik.values,
                        "KpiIndicatorMandalEntry",
                      )
                    }
                  >
                    {" "}
                    <span style={{ color: "green" }}>
                      {" "}
                      Excel
                      <AiFillFileExcel style={{ fontSize: "18px" }} />{" "}
                    </span>{" "}
                  </Button>
                  <div className="kp-indicatortable ">
                    {" "}
                    <div
                      id="table-scroll"
                      className="mt-5 mb-5"
                      style={{
                        maxHeight: "400px",
                        overflowY: "auto",
                        overflowX: "hidden",
                      }}
                    >
                      <table
                        className="table table-bordered custom-table table-responsive sticky-table"
                        id="my-table"
                      >
                        <thead style={{ borderRadius: "10px 10px 0px 0px" }}>
                          <tr className="text-center">
                            {" "}
                            <th className="sticky-col sticky-sno">
                              Sl.No.
                            </th>{" "}
                            <th className="sticky-col sticky-mandal">
                              INDICATOR
                            </th>{" "}
                            <th>UNIT</th>{" "}
                            <th style={{ width: "20%" }}>
                              {" "}
                              NUMERATOR/DENOMINATOR
                            </th>{" "}
                            <th> ACHIEVED VALUE</th>{" "}
                            {formik.values.Indicators?.some(
                              (item) => Number(item.ind_phase) === 4,
                            ) && <th>Remarks</th>}
                            {isFY2025OrLater(formik.values.year) && (
                              <th>
                                {" "}
                                TARGETS <br />
                                {formik.values.year}
                              </th>
                            )}{" "}
                          </tr>
                        </thead>
                        <tbody>
                          {EntryData?.length === 0 ||
                            EntryData?.length === undefined ? (
                            <tr>
                              {" "}
                              <td
                                className="text-center"
                                colSpan={
                                  isFY2025OrLater(formik.values.year)
                                    ? "6"
                                    : "5"
                                }
                              >
                                {" "}
                                <b style={{ color: "red" }}>
                                  Details Not Found
                                </b>{" "}
                              </td>{" "}
                            </tr>
                          ) : (
                            (() => {
                              return EntryData?.map((detail, i) => {
                                return (
                                  <tr key={i}>
                                    <td
                                      style={{ textAlign: "center" }}
                                      className="sticky-col sticky-sno"
                                    >
                                      {i + 1}
                                    </td>{" "}
                                    <td
                                      className="sticky-col sticky-mandal"
                                      style={{
                                        textAlign: "left",
                                        wordWrap: "break-word",
                                        whiteSpace: "normal",
                                      }}
                                    >
                                      {detail.ind_type === "N" &&
                                        (isFY2025OrLater(formik.values.year)
                                          ? detail.targets_2025
                                          : {}) &&
                                        buttonenb &&
                                        [0, "0", null].includes(
                                          detail.status_id,
                                        ) && (
                                          <img
                                            src="../images/new3.gif"
                                            width="20px"
                                            alt="new"
                                            style={{ marginRight: "5px" }}
                                          />
                                        )}
                                      {detail.indicator_name}
                                    </td>{" "}
                                    <td style={{ textAlign: "left" }}>
                                      {detail.unit_name}
                                    </td>
                                    <td className="text-right text-end">
                                      {detail.no_of_columns === 3 ||
                                        detail.no_of_columns === 4 ? (
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "5px",
                                          }}
                                        >
                                          {" "}
                                          <Field
                                            autoComplete="off"
                                            name={`Indicators[${i}].numerator`}
                                            className="form-control"
                                            type="text"
                                            style={{ textAlign: "right" }}
                                            disabled={
                                              formik.values.Indicators[i]
                                                ?.targetenb ||
                                                (formik.values.Indicators[i]
                                                  .ind_type === "N" &&
                                                  [2, 4].includes(
                                                    formik.values.Indicators[i]
                                                      .status_id,
                                                  )) ||
                                                (formik.values.Indicators[i]
                                                  .ind_type === "O" &&
                                                  hasOldStatus)
                                                ? true
                                                : false
                                            }
                                            onBlur={(e) => {
                                              handleInputChange(
                                                e,
                                                i,
                                                "numerator",
                                                formik.values.Indicators[i]
                                                  ?.iszero,
                                              );
                                              denominatorchange(
                                                i,
                                                detail.unit_cat_id,
                                              );
                                              formik.handleChange(e);
                                            }}
                                            onInput={(e) => {
                                              if (detail.unit_cat_id === 1) {
                                                allowNumberswithMaxLengthcatidtypeOnly(
                                                  e,
                                                  formik.values.Indicators[i]
                                                    ?.maxLength,
                                                  formik.values.Indicators[i]
                                                    ?.type,
                                                  3,
                                                  formik.values.Indicators[i]
                                                    ?.iszero,
                                                );
                                              } else {
                                                allowNumberswithMaxLengthtypeOnly(
                                                  e,
                                                  formik.values.Indicators[i]
                                                    ?.maxLength,
                                                  formik.values.Indicators[i]
                                                    ?.type,
                                                  3,
                                                  formik.values.Indicators[i]
                                                    ?.iszero,
                                                );
                                              }
                                            }}
                                            {...restrictToPasteEightDotThreeHandler(
                                              formik,
                                              "numerator",
                                              i,
                                              formik.values.Indicators[i]
                                                ?.iszero,
                                              detail.unit_cat_id,
                                            )}
                                          />{" "}
                                          <span style={{ fontSize: "15px" }}>
                                            /
                                          </span>
                                          <Field
                                            autoComplete="off"
                                            name={`Indicators[${i}].denominator`}
                                            className="form-control"
                                            onBlur={(e) => {
                                              handleInputChange(
                                                e,
                                                i,
                                                "denominator",
                                                formik.values.Indicators[i]
                                                  ?.iszero,
                                              );
                                              denominatorchange(
                                                i,
                                                detail.unit_cat_id,
                                              );
                                              formik.handleChange(e);
                                            }}
                                            type="text"
                                            style={{ textAlign: "right" }}
                                            // disabled={( fieldenb|| formik.values.Indicators[i]?.targetenb) ? true: false}
                                            disabled={
                                              formik.values.Indicators[i]
                                                ?.targetenb ||
                                                (formik.values.Indicators[i]
                                                  .ind_type === "N" &&
                                                  [2, 4].includes(
                                                    formik.values.Indicators[i]
                                                      .status_id,
                                                  )) ||
                                                (formik.values.Indicators[i]
                                                  .ind_type === "O" &&
                                                  hasOldStatus)
                                                ? true
                                                : false
                                            }
                                            onInput={(e) => {
                                              denomallowNumberswithMaxLengthtypeOnly(
                                                e,
                                                formik.values.Indicators[i]
                                                  ?.maxLength,
                                                formik.values.Indicators[i]
                                                  ?.type,
                                                3,
                                              );
                                            }}
                                            {...restrictToPasteOnlyEightDotThreeAllowKeyPress(
                                              formik,
                                              "denominator",
                                              i,
                                            )}
                                          />{" "}
                                        </div>
                                      ) : (
                                        ""
                                      )}{" "}
                                    </td>
                                    {roleid !== "60" && roleid !== "5" ? (
                                      <>
                                        {" "}
                                        <td className="text-right text-end ">
                                          {" "}
                                          <div className="d-flex align-items-center">
                                            {detail.unit_cat_id !== 13 ? (
                                              <Field
                                                autoComplete="off"
                                                className="form-control"
                                                name={`Indicators[${i}].entry_value`}
                                                value={
                                                  detail.unit_cat_id === 1
                                                    ? formatNumberIndianWithDecimal(
                                                      formik.values
                                                        .Indicators[i]
                                                        ?.entry_value,
                                                    )
                                                    : formik.values.Indicators[
                                                      i
                                                    ]?.entry_value
                                                }
                                                onBlur={(e) => {
                                                  handleInputChange(
                                                    e,
                                                    i,
                                                    "entry_value",
                                                    formik.values.Indicators[i]
                                                      ?.iszero,
                                                  );
                                                  formik.handleChange(e);
                                                }}
                                                onInput={(e) => {
                                                  if (
                                                    detail.unit_cat_id === 1
                                                  ) {
                                                    allowNumberswithMaxLengthcatidtypeOnly(
                                                      e,
                                                      formik.values.Indicators[
                                                        i
                                                      ]?.maxLength,
                                                      formik.values.Indicators[
                                                        i
                                                      ]?.type,
                                                      3,
                                                      formik.values.Indicators[
                                                        i
                                                      ]?.iszero,
                                                    );
                                                  } else {
                                                    allowNumberswithMaxLengthtypeOnly(
                                                      e,
                                                      formik.values.Indicators[
                                                        i
                                                      ]?.maxLength,
                                                      formik.values.Indicators[
                                                        i
                                                      ]?.type,
                                                      3,
                                                      formik.values.Indicators[
                                                        i
                                                      ]?.iszero,
                                                    );
                                                  }
                                                }}
                                                {...restrictToPasteEightDotThreeHandler(
                                                  formik,
                                                  "entry_value",
                                                  i,
                                                  formik.values.Indicators[i]
                                                    ?.iszero,
                                                  detail.unit_cat_id,
                                                )}
                                                disabled={
                                                  ![1, 2].includes(
                                                    detail.no_of_columns,
                                                  ) ||
                                                    (formik.values.Indicators[i]
                                                      .ind_type === "N" &&
                                                      [2, 4].includes(
                                                        formik.values.Indicators[
                                                          i
                                                        ].status_id,
                                                      )) ||
                                                    (formik.values.Indicators[i]
                                                      .ind_type === "O" &&
                                                      hasOldStatus) ||
                                                    formik.values.Indicators[i]
                                                      ?.targetenb
                                                    ? true
                                                    : false
                                                }
                                                type="text"
                                                style={{ textAlign: "right" }}
                                              />
                                            ) : (
                                              <Field
                                                component="select"
                                                name={`Indicators[${i}].entry_value`}
                                                className="form-control mb-3"
                                                style={{ fontWeight: "bold" }}
                                                disabled={
                                                  ![1, 2].includes(
                                                    detail.no_of_columns,
                                                  ) ||
                                                    (formik.values.Indicators[i]
                                                      .ind_type === "N" &&
                                                      [2, 4].includes(
                                                        formik.values.Indicators[
                                                          i
                                                        ].status_id,
                                                      )) ||
                                                    (formik.values.Indicators[i]
                                                      .ind_type === "O" &&
                                                      hasOldStatus) ||
                                                    formik.values.Indicators[i]
                                                      ?.targetenb
                                                    ? true
                                                    : false
                                                }
                                              >
                                                {" "}
                                                <option value="">
                                                  --Select--
                                                </option>{" "}
                                                <option value="100">
                                                  TOP ACHIEVERS
                                                </option>{" "}
                                                <option value="75">
                                                  ACHIEVERS
                                                </option>{" "}
                                                <option value="50">
                                                  FAST MOVERS
                                                </option>{" "}
                                                <option value="25">
                                                  ASPIRERS
                                                </option>{" "}
                                              </Field>
                                            )}
                                            {detail.cal_formula && (
                                              <OverlayTrigger
                                                placement="top"
                                                trigger={["hover", "focus"]}
                                                overlay={
                                                  <Tooltip
                                                    id={`tooltip-info-${detail.indicator_id}`}
                                                    className="custom-tooltipp"
                                                  >
                                                    {" "}
                                                    <strong
                                                      style={{
                                                        fontSize: "18px",
                                                      }}
                                                    >
                                                      Formula:{" "}
                                                    </strong>{" "}
                                                    <br />{" "}
                                                    {detail.cal_formula}{" "}
                                                  </Tooltip>
                                                }
                                              >
                                                <span
                                                  style={{
                                                    display: "inline-flex",
                                                  }}
                                                >
                                                  <img
                                                    src="images/info3.png"
                                                    alt="info"
                                                    style={{
                                                      width: "20px",
                                                      height: "20px",
                                                      marginLeft: "10px",
                                                    }}
                                                    className="img-fluid"
                                                  />{" "}
                                                </span>
                                              </OverlayTrigger>
                                            )}
                                            {/* {detail.cal_formula && (
                       <OverlayTrigger
                         placement="top"
                         trigger={["hover","focus"]}
                         container={typeof document !== 'undefined' ? document.body : undefined}
                         overlay={<Tooltip id={`tooltip-info-${detail.indicator_id}`} className="custom-tooltipp"><strong style={{ fontSize: "18px" }}>Formula: </strong><br />{detail.cal_formula}</Tooltip>}
                       >
                         <img src="images/info3.png" alt="message" style={{ width: "20px", height: "20px", marginLeft: "10px" }} className="img-fluid" />
                       </OverlayTrigger>
                     )}  */}
                                          </div>{" "}
                                        </td>{" "}
                                      </>
                                    ) : (
                                      <td
                                        className="text-right text-end "
                                        style={{ textAlign: "left" }}
                                      >
                                        {" "}
                                        <div className="d-flex align-items-center justify-content-between">
                                          {" "}
                                          {detail.indicator_value}
                                          {detail.cal_formula && (
                                            <OverlayTrigger
                                              placement="top"
                                              trigger={["hover", "focus"]}
                                              overlay={
                                                <Tooltip
                                                  id={`tooltip-info-${detail.indicator_id}`}
                                                  className="custom-tooltipp"
                                                >
                                                  {" "}
                                                  <strong
                                                    style={{ fontSize: "18px" }}
                                                  >
                                                    Formula:{" "}
                                                  </strong>{" "}
                                                  <br />{" "}
                                                  {detail.cal_formula}{" "}
                                                </Tooltip>
                                              }
                                            >
                                              <span
                                                style={{
                                                  display: "inline-flex",
                                                }}
                                              >
                                                {" "}
                                                <img
                                                  src="images/info3.png"
                                                  alt="info"
                                                  style={{
                                                    width: "20px",
                                                    height: "20px",
                                                    marginLeft: "10px",
                                                  }}
                                                  className="img-fluid"
                                                />{" "}
                                              </span>
                                            </OverlayTrigger>
                                          )}
                                          {/* {detail.cal_formula && (
                       <OverlayTrigger
                         placement="top"
                         trigger={["hover","focus"]}
                         container={typeof document !== 'undefined' ? document.body : undefined}
                         overlay={<Tooltip id={`tooltip-${i}`} className="custom-tooltipp"><strong style={{ fontSize: "18px" }}>Formula: </strong><br />{detail.cal_formula}</Tooltip>}
                       >
                         <img src="images/info3.png" alt="message" style={{ width: "20px", height: "20px", marginLeft: "10px" }} className="img-fluid" />
                       </OverlayTrigger>
                     )} */}
                                        </div>{" "}
                                      </td>
                                    )}
                                    {formik.values.Indicators?.some(
                                      (item) => Number(item.ind_phase) === 4,
                                    ) && (
                                        <td>
                                          {Number(
                                            formik.values.Indicators[i]
                                              ?.ind_phase,
                                          ) === 4 && (
                                              <Field
                                                as="textarea"
                                                name={`Indicators[${i}].economicRemarks`}
                                                className="form-control"
                                                disabled={
                                                  ![1, 2].includes(
                                                    detail.no_of_columns,
                                                  ) ||
                                                    (formik.values.Indicators[i]
                                                      .ind_type === "N" &&
                                                      [2, 4].includes(
                                                        formik.values.Indicators[i]
                                                          .status_id,
                                                      )) ||
                                                    (formik.values.Indicators[i]
                                                      .ind_type === "O" &&
                                                      hasOldStatus) ||
                                                    formik.values.Indicators[i]
                                                      ?.targetenb
                                                    ? true
                                                    : false
                                                }
                                              />
                                            )}
                                        </td>
                                      )}
                                    {isFY2025OrLater(formik.values.year) && (
                                      <td className="text-right text-end ">
                                        {detail.unit_cat_id === 1
                                          ? formatNumberIndianWithDecimal(
                                            detail.targets_2025,
                                          )
                                          : detail.targets_2025}
                                      </td>
                                    )}
                                  </tr>
                                );
                              });
                            })()
                          )}
                        </tbody>{" "}
                      </table>{" "}
                    </div>{" "}
                  </div>
                  {roleid == "8" ? (
                    <div className="bottom-buttons d-flex justify-content-center mb-5">
                      {" "}
                      {![200].includes(Roleeid) && (
                        <>
                          {" "}
                          {statusId === "0" && (
                            <Button
                              variant=""
                              size="sm"
                              className="save-btn me-4"
                              onClick={() => SaveEntryData()}
                            >
                              {" "}
                              Save <FaRegSave className="ms-1 s-icon" />{" "}
                            </Button>
                          )}{" "}
                          {(statusId === "1" || statusId === "2") && (
                            <Button
                              variant=""
                              size="sm"
                              className="save-btn me-4"
                              onClick={() => SaveEntryData()}
                            >
                              {" "}
                              Update <FaRegSave className="ms-1 s-icon" />{" "}
                            </Button>
                          )}{" "}
                        </>
                      )}{" "}
                    </div>
                  ) : (
                    <>
                      {buttonenb && (
                        <div className="bottom-buttons d-flex justify-content-center mb-5">
                          <Button
                            variant=""
                            size="sm"
                            className="save-btn me-4"
                            onClick={() => SaveEntryData()}
                          >
                            Save <FaRegSave className="ms-1 s-icon" />
                          </Button>
                          <Button
                            variant=""
                            size="sm"
                            className="next-btn me-4"
                            onClick={() => submitData()}
                          >
                            Forward{" "}
                            <IoReturnDownForward
                              style={{ fontSize: "18px", marginLeft: "5px" }}
                            />
                          </Button>
                        </div>
                      )}
                      {Roleeid !== 31 &&
                        Roleeid !== 3 &&
                        roleid !== "31" &&
                        roleid !== "3" &&
                        Roleeid !== 200 && (
                          <div className="bottom-buttons d-flex justify-content-center  mb-5">
                            {" "}
                            <Button
                              variant=""
                              size="sm"
                              className="save-btn  mx-4 mt-4"
                              onClick={() => UpdateCpo()}
                            >
                              {" "}
                              Update <FaRegSave className="ms-1 s-icon" />{" "}
                            </Button>{" "}
                            <Button
                              variant=""
                              size="sm"
                              className="next-btn  mx-4 mt-4"
                              onClick={() => ForwardHodpop()}
                            >
                              {" "}
                              Approve <FaRegSave className="ms-1 s-icon" />{" "}
                            </Button>{" "}
                          </div>
                        )}{" "}
                    </>
                  )}
                </Col>
                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={3}
                  xl={3}
                  xxl={3}
                  className="mt-5"
                >
                  {" "}
                  <div className="card-all">
                    {" "}
                    <h2>Activity Track</h2>
                    {workFlow && workFlow.length === 0 ? (
                      <div className="card-info d-flex">
                        {" "}
                        <div className="user-icon-box">
                          {" "}
                          <div className="user-icon">
                            <RiUserFollowLine />
                          </div>{" "}
                        </div>{" "}
                        <div className="user-details">
                          {" "}
                          <div className="user-details-text">
                            {" "}
                            <h3>
                              Current Status: Mandal Officer not yet submitted
                            </h3>{" "}
                          </div>{" "}
                        </div>{" "}
                      </div>
                    ) : (
                      workFlow?.map((item, index) => (
                        <>
                          {item.uname !== null ? (
                            <div key={index} className="card-info d-flex">
                              <div className="user-icon-box">
                                {" "}
                                <div className="user-icon">
                                  <RiUserFollowLine />
                                </div>{" "}
                              </div>{" "}
                              <div className="user-details">
                                {" "}
                                <div className="user-details-text">
                                  {" "}
                                  <h3>{item.uname}</h3>{" "}
                                  <p>{item.submitted_date}</p>{" "}
                                </div>
                                <OverlayTrigger
                                  placement="top"
                                  trigger={["hover", "focus"]}
                                  container={
                                    typeof document !== "undefined"
                                      ? document.body
                                      : undefined
                                  }
                                  overlay={
                                    <Tooltip
                                      id={`tooltip-${index}`}
                                      className="custom-tooltipp"
                                    >
                                      <strong style={{ fontSize: "18px" }}>
                                        Remarks:{" "}
                                      </strong>
                                      <br />
                                      {item.remarks}
                                    </Tooltip>
                                  }
                                >
                                  <img
                                    src="images/message.webp"
                                    alt="message"
                                    className="img-fluid"
                                  />
                                </OverlayTrigger>
                              </div>{" "}
                            </div>
                          ) : (
                            ""
                          )}
                        </>
                      ))
                    )}
                    {workFlow.length !== 0 ? (
                      <p
                        style={{ fontWeight: "bold", color: "#178a00" }}
                        className="user-details1"
                      >
                        <h3>
                          {" "}
                          <span style={{ color: "#178a00" }}>
                            Current Status
                          </span>
                          : {currentstatus}
                        </h3>
                        <br />
                      </p>
                    ) : null}
                  </div>{" "}
                </Col>{" "}
              </Row>
            )}
            {cpoTableenb && (
              <Row className="justify-content-center mt-3">
                <Col xs={6} sm={12} lg={9} md={9} xl={9} xxl={9}>
                  <div className="input-group mt-2">
                    <div className="input-group-prepend">
                      {" "}
                      <div
                        class="input-group-text group_txt11"
                        id="btnGroupAddon"
                      >
                        <AiOutlineSearch />
                      </div>
                    </div>{" "}
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search"
                      onChange={(event) => setSearchText(event.target.value)}
                    />{" "}
                  </div>
                  <div
                    id="table-scroll"
                    className="mt-1 mb-5"
                    style={{
                      maxHeight: "400px",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    <table
                      hover
                      className="table table-bordered custom-table table-responsive "
                    >
                      <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
                        <tr className="text-center">
                          {" "}
                          <th>Sl.No.</th> <th>Mandal</th>{" "}
                          <th>Initiated Indicators</th>{" "}
                          <th>Mandal Officer Submission Date</th>{" "}
                          <th>Status</th>{" "}
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData?.length === 0 ? (
                          <tr>
                            {" "}
                            <td
                              className="text-center fw-bold"
                              style={{ color: "red" }}
                              colSpan={5}
                            >
                              {" "}
                              Details Not Found{" "}
                            </td>{" "}
                          </tr>
                        ) : (
                          filteredData?.map((detail, i) => (
                            <tr
                              key={i}
                              className={
                                detail.indicator_count > 0
                                  ? "highlighted-row"
                                  : ""
                              }
                            >
                              {" "}
                              <td className="text-center">{i + 1}</td>{" "}
                              <td className="text-left text-start">
                                {" "}
                                {detail.indicator_count > 0 ? (
                                  <Link
                                    style={{
                                      cursor: "pointer",
                                      color: "red",
                                      textDecoration: "none",
                                      fontFamily: "sans-serif",
                                    }}
                                    onClick={() => Subdata(detail)}
                                  >
                                    {" "}
                                    {detail.mandal_name}{" "}
                                  </Link>
                                ) : (
                                  detail.mandal_name
                                )}{" "}
                              </td>{" "}
                              <td className="text-center">
                                {" "}
                                {detail.indicator_count > 0 ? (
                                  <Link
                                    style={{
                                      cursor: "pointer",
                                      color: "red",
                                      textDecoration: "none",
                                      fontFamily: "sans-serif",
                                    }}
                                    onClick={() => Subdata(detail)}
                                  >
                                    {" "}
                                    {detail.indicator_count}{" "}
                                  </Link>
                                ) : (
                                  detail.indicator_count
                                )}{" "}
                              </td>{" "}
                              <td className="text-center">
                                {" "}
                                {detail.indicator_count > 0 ? (
                                  <Link
                                    style={{
                                      cursor: "pointer",
                                      color: "red",
                                      textDecoration: "none",
                                      fontFamily: "sans-serif",
                                    }}
                                    onClick={() => Subdata(detail)}
                                  >
                                    {" "}
                                    {detail.t_a_submitted_date}{" "}
                                  </Link>
                                ) : (
                                  detail.t_a_submitted_date
                                )}{" "}
                              </td>{" "}
                              <td className="text-center">
                                {" "}
                                {detail.indicator_count > 0 ? (
                                  <Link
                                    style={{
                                      cursor: "pointer",
                                      color: "red",
                                      textDecoration: "none",
                                      fontFamily: "sans-serif",
                                    }}
                                    onClick={() => Subdata(detail)}
                                  >
                                    {" "}
                                    {detail.status}{" "}
                                  </Link>
                                ) : (
                                  detail.status
                                )}{" "}
                              </td>{" "}
                            </tr>
                          ))
                        )}{" "}
                      </tbody>
                    </table>{" "}
                  </div>{" "}
                </Col>{" "}
              </Row>
            )}

            <Modal
              fade={false}
              className="newmodal"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={addModal}
            >
              <Modal.Header>
                {roleid === "32" || roleid === "2" ? (
                  <Modal.Title
                    className="text-center  fw-bold"
                    style={{
                      margin: "0 auto",
                      color: "black",
                      fontFamily: "'Times New Roman', Times, serif",
                    }}
                  >
                    Confirm & Approve
                  </Modal.Title>
                ) : (
                  <Modal.Title
                    className="text-center  fw-bold"
                    style={{
                      margin: "0 auto",
                      color: "black",
                      fontFamily: "'Times New Roman', Times, serif",
                    }}
                  >
                    Forward To
                  </Modal.Title>
                )}
                <span
                  role="button"
                  tabIndex={0}
                  onClick={handleClose}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handleClose();
                    }
                  }}
                  style={{ cursor: "pointer", color: "white" }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "red")}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "white")}
                >
                  {" "}
                  &#215;{" "}
                </span>{" "}
              </Modal.Header>
              <Modal.Body className="p-5">
                {" "}
                <Modal.Dialog className="internal">
                  {!["60", "32", "2", "5"].includes(roleid) && (
                    <Modal.Body>
                      <p className="d-flex">
                        {" "}
                        <FaUserCheck className="usericon" />
                        <Field
                          type="text"
                          style={{
                            marginBottom: "0.5rem",
                            color: "black",
                            fontSize: "13px",
                            fontWeight: "bold",
                            fontFamily: "Arial, sans-serif",
                          }}
                          value={
                            roleid === "31" || roleid === "3"
                              ? `District Officer(${deptName})`
                              : ""
                          }
                          className="form-control"
                          disabled={true}
                        />
                      </p>{" "}
                    </Modal.Body>
                  )}
                  <Modal.Footer>
                    {" "}
                    Remarks <sup className="mandatort">*</sup>{" "}
                    <Field
                      as="textarea"
                      name="remarks"
                      rows={2}
                      cols={40}
                      style={{ resize: "none" }}
                      maxLength={200}
                    />{" "}
                  </Modal.Footer>
                </Modal.Dialog>
              </Modal.Body>
              <Modal.Footer>
                {" "}
                <button type="button" className="conform" onClick={checkVal}>
                  {" "}
                  Confirm <FaRegFile />
                </button>{" "}
              </Modal.Footer>
            </Modal>

            <Modal
              fade={false}
              className="newmodal"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={showModal}
              onHide={null}
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header>
                {" "}
                <Modal.Title></Modal.Title>{" "}
                <span
                  role="button"
                  tabIndex={0}
                  onClick={handleClosepop}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handleClosepop();
                    }
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "red")}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "white")}
                  style={{ fontSize: "30px", cursor: "pointer" }}
                  className="me-1"
                >
                  {" "}
                  &#215;{" "}
                </span>{" "}
              </Modal.Header>

              <Modal.Body
                className="p-3 d-flex flex-column justify-content-center align-items-center"
                onKeyDown={handleKeyDown}
              >
                {" "}
                <div className="text-center">
                  {" "}
                  <img
                    src="images/question.gif"
                    style={{ width: "70px", marginBottom: "10px" }}
                    alt="Warning Icon"
                  />{" "}
                  <p className="fw-bold" style={{ fontSize: "17px" }}>
                    {" "}
                    Are you sure you want to{" "}
                    {roleid === "31" || roleid === "3" ? "Forward" : "Approve"}?
                    Once Submitted no further changes will be allowed.{" "}
                  </p>{" "}
                </div>{" "}
              </Modal.Body>
              <Modal.Footer>
                {" "}
                {(roleid === "31" || roleid === "3") && (
                  <button
                    type="button"
                    className="conform"
                    onClick={() => ForwardDataCpo()}
                  >
                    {" "}
                    Yes{" "}
                  </button>
                )}{" "}
                {(roleid === "32" || roleid === "2") && (
                  <button
                    type="button"
                    className="conform"
                    onClick={() => ApproveData()}
                  >
                    {" "}
                    Yes{" "}
                  </button>
                )}{" "}
                <button
                  type="button"
                  className="cancel"
                  onClick={handleClosepop}
                >
                  {" "}
                  No{" "}
                </button>{" "}
              </Modal.Footer>
            </Modal>
          </Form>{" "}
        </FormikProvider>{" "}
      </Container>
      <AlertModal
        show={showAlert}
        titleText={alertData.titleText}
        alertText={alertData.alertText}
        onClose={closeAlert}
      />
    </>
  );
}
